/* =========================================================
   FRESHCHAT
   ---------------------------------------------------------
   Abre Freshchat al pulsar enlaces con #ayuda
   y cierra posibles overlays/modales antes de abrirlo.
========================================================= */

document.addEventListener("click", function(e) {
  const link = e.target.closest('a[href="#ayuda"], a[href*="#ayuda"]');
  if (!link) return;

  e.preventDefault();
  e.stopPropagation();

  document.body.classList.add('freshchat-open');

  document.dispatchEvent(new KeyboardEvent('keydown', {
    key: 'Escape',
    code: 'Escape',
    keyCode: 27,
    which: 27,
    bubbles: true
  }));

  window.dispatchEvent(new KeyboardEvent('keydown', {
    key: 'Escape',
    code: 'Escape',
    keyCode: 27,
    which: 27,
    bubbles: true
  }));

  setTimeout(function() {
    if (window.fcWidget && typeof window.fcWidget.open === "function") {
      window.fcWidget.show();
      window.fcWidget.open();
    }
  }, 400);
}, true);




/* =========================================================
   TRUSTED SHOPS + FRESHCHAT - BAJAR Z-INDEX FLOTANTES
========================================================= */
(function () {
  function lowerFloatingWidgetsZIndex() {

    /* Trusted Shops */
    document.querySelectorAll('[id^="trustbadge-container-"]').forEach(function (el) {
      el.style.setProperty('z-index', '29', 'important');
    });

    /* Freshchat */
    const freshchat = document.querySelector('#fc_frame');

    if (freshchat) {
      freshchat.style.setProperty('z-index', '30', 'important');
    }
  }

  lowerFloatingWidgetsZIndex();

  const observer = new MutationObserver(lowerFloatingWidgetsZIndex);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style']
  });

  window.addEventListener('load', lowerFloatingWidgetsZIndex);
})();












(function () {

  function balukaAddComparePrices() {

    document.querySelectorAll('input[data-radio-type="one_time_purchase"]').forEach(function(input) {

      var comparePrice = input.getAttribute('data-variant-compare-at-price');

      if (!comparePrice || comparePrice.trim() === '') return;

      var label = input.closest('label.title_and_price_wrapper');
      if (!label) return;

      var priceBox = label.querySelector('.in_widget_price');
      if (!priceBox) return;

      if (priceBox.querySelector('.baluka-compare-price')) return;

      var compareSpan = document.createElement('span');
      compareSpan.className = 'baluka-compare-price';
      compareSpan.textContent = comparePrice;

      priceBox.appendChild(compareSpan);

    });

  }

  balukaAddComparePrices();

  setTimeout(balukaAddComparePrices, 300);
  setTimeout(balukaAddComparePrices, 800);
  setTimeout(balukaAddComparePrices, 1500);
  setTimeout(balukaAddComparePrices, 3000);

  document.addEventListener('change', function() {
    setTimeout(balukaAddComparePrices, 150);
  });

  var observer = new MutationObserver(function() {
    balukaAddComparePrices();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
















/* Eliminamos minituras en PDP y añadimos dots */



(function () {
  let balukaDotsRunning = false;
  let balukaDotsGalleryId = '';

  function initBalukaPdpDots() {
    if (window.innerWidth > 749) return;
    if (balukaDotsRunning) return;

    balukaDotsRunning = true;

    const rioGallery = document.querySelector('.main-product__image-content .rio-media-gallery');
    if (!rioGallery) {
      balukaDotsRunning = false;
      return;
    }

    const wrapper = rioGallery.querySelector('#pwzrswiper-container-wrapper');
    const swiperWrapper = rioGallery.querySelector('#pwzrswiper-wrapper');
    const slides = Array.from(rioGallery.querySelectorAll('.pwzrswiper-slide'));

    if (!wrapper || !swiperWrapper || slides.length < 2) {
      balukaDotsRunning = false;
      return;
    }

    const currentGalleryId = slides.map(slide => slide.querySelector('img')?.src || '').join('|');

    if (
      rioGallery.querySelector('.baluka-pdp-mobile-pagination') &&
      balukaDotsGalleryId === currentGalleryId
    ) {
      balukaDotsRunning = false;
      return;
    }

    balukaDotsGalleryId = currentGalleryId;

    rioGallery.querySelectorAll('.baluka-pdp-mobile-pagination').forEach(el => el.remove());

    const pagination = document.createElement('xo-carousel-pagination');
    pagination.className = 'xo-carousel-paginator xo-carousel-paginator--sticks xo-carousel-paginator--radius baluka-pdp-mobile-pagination';
    pagination.setAttribute('style', '--pag-align: center');

    slides.forEach(function (slide, index) {
      const bullet = document.createElement('xo-carousel-bullet');
      bullet.setAttribute('xo-index', index);
      bullet.setAttribute('xo-page', index + 1);
      bullet.setAttribute('role', 'button');
      bullet.setAttribute('tabindex', '0');
      bullet.setAttribute('aria-label', 'Bullet ' + (index + 1));

      if (slide.classList.contains('pwzrswiper-slide-active')) {
        bullet.setAttribute('xo-active', '');
      }

      bullet.innerHTML = '<span class="carousel-bullet"></span>';

      bullet.addEventListener('click', function () {
        slide.click();
      });

      pagination.appendChild(bullet);
    });

    wrapper.insertAdjacentElement('afterend', pagination);

    function updateActiveBullet() {
      const activeSlide = rioGallery.querySelector('.pwzrswiper-slide-active');
      if (!activeSlide) return;

      const activeIndex = slides.indexOf(activeSlide);

      pagination.querySelectorAll('xo-carousel-bullet').forEach(function (bullet, index) {
        bullet.toggleAttribute('xo-active', index === activeIndex);
      });
    }

    swiperWrapper.addEventListener('transitionend', updateActiveBullet);
    swiperWrapper.addEventListener('touchend', function () {
      setTimeout(updateActiveBullet, 200);
    }, { passive: true });

    setTimeout(updateActiveBullet, 100);

    balukaDotsRunning = false;
  }

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(initBalukaPdpDots, 800);
  });

  document.addEventListener('change', function () {
    setTimeout(initBalukaPdpDots, 900);
  });

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('.rio-options') ||
      event.target.closest('[data-option]') ||
      event.target.closest('.PwzrGrid-root')
    ) {
      setTimeout(initBalukaPdpDots, 900);
    }
  });
})();